export function AutomationFormHeader(props: { readonly mode: "create" | "edit" }) {
  const description = props.mode === "create" ? "Cloud by default" : "Changes apply to future runs";
  // No title, no back link: the bar already says `Automations / New
  // automation` on create and `Automations / <name> / Edit` on edit, with the
  // "Automations" ancestor rendered as a clickable crumb — a second one here
  // duplicated it. Same convention as ForgeAutomationsPage's own header.
  return (
    <header className="flex min-h-10 shrink-0 items-center border-b border-border/60 px-4 sm:px-6">
      <p className="truncate text-xs text-muted-foreground">{description}</p>
    </header>
  );
}
